import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fRef } from '../../utils/React.js';
import { hostClass } from './ElevatorAnimation.styles.js';

var defaultProps = {
  active: true
};
var ElevatorAnimationPresentation = fRef(function (props) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;

  var children = props.children,
      noMargin = props.noMargin,
      className = props.className,
      isVisible = props.isVisible,
      hostRef = props.hostRef,
      active = props.active;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "no-margin"), noMargin), _cleanupClassObject)),
    ref: hostRef
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner__visible"), isVisible && active), _cleanupClassObject2))
  }, children), active && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-overlay"), true), _defineProperty(_cleanupClassObject3, "".concat(hostClass, "-overlay__visible"), isVisible), _cleanupClassObject3))
  }));
}, defaultProps);

export { ElevatorAnimationPresentation, defaultProps };
